
import React, { Component } from 'react'
import { Card, notification, Space, Upload, Button, Empty, Collapse, Table, Typography } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import Http from '../../../utils/http'
import Slider from 'react-slick'
import './tabs.css'

const { Panel } = Collapse
const { Title } = Typography


class WeightBalance extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: [],
      tab: 'oew',
      activeAircraftKeys: []
    }
  }

  componentDidMount() {
    this.fetchData()
  }

  fetchData = async () => {
    try {
      Http.get('/w_b/oew').then((response) => {
        this.setState({ data: response.data.data })
      })
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching data:', error)
    }
  }

  getAircraftPanelKey = (item, index) => `${item?.type || 'type'}-${index}`

  getAircraftPanelKeys = (data = []) => data.map((item, index) => this.getAircraftPanelKey(item, index))

  handleAircraftAccordionChange = (keys) => {
    this.setState({ activeAircraftKeys: Array.isArray(keys) ? keys : keys ? [keys] : [] })
  }

  toggleAllAircraft = () => {
    const allKeys = this.getAircraftPanelKeys(this.state.data)
    const isAllExpanded = allKeys.length > 0 && this.state.activeAircraftKeys.length === allKeys.length
    this.setState({ activeAircraftKeys: isAllExpanded ? [] : allKeys })
  }

  getExtraColumnNames = (rows = []) => {
    const hiddenColumns = ['ship', 'dom_oew_adj_wt', 'intl_oew_adj_wt', 'config']
    const extraColumns = []

    rows.forEach((value) => {
      Object.keys(value || {}).forEach((key) => {
        if (!hiddenColumns.includes(key) && !extraColumns.includes(key)) {
          extraColumns.push(key)
        }
      })
    })

    return extraColumns
  }

  getOewColumns = (extraColumns = []) => {
    const baseColumns = [
      {
        title: 'Ship',
        dataIndex: 'ship',
        key: 'ship',
        className: 'wb-col-ship',
        width: 90,
        render: (value) => value || '-'
      },
      {
        title: 'Dom OEW Adj Wt',
        dataIndex: 'dom_oew_adj_wt',
        key: 'dom_oew_adj_wt',
        className: 'wb-col-dom',
        width: 150,
        render: (value) => value || '-'
      },
      {
        title: 'Intl OEW Adj Wt',
        dataIndex: 'intl_oew_adj_wt',
        key: 'intl_oew_adj_wt',
        className: 'wb-col-intl',
        width: 150,
        render: (value) => value || '-'
      },
      {
        title: 'Config',
        dataIndex: 'config',
        key: 'config',
        className: 'wb-col-config',
        width: 120,
        render: (value) => <span className='wb-config-pill'>{value || '-'}</span>
      }
    ]

    const dynamicColumns = extraColumns.map((column) => ({
      title: column.charAt(0).toUpperCase() + column.slice(1).split('_').join(' '),
      dataIndex: column,
      key: column,
      className: 'wb-col-extra',
      width: 120,
      render: (value) => value || '-'
    }))

    return [...baseColumns, ...dynamicColumns]
  }

  oew = () => {
    const { data, activeAircraftKeys } = this.state
    const allPanelKeys = this.getAircraftPanelKeys(data)
    const isAllExpanded = allPanelKeys.length > 0 && activeAircraftKeys.length === allPanelKeys.length

    return (
      <div className='wb-panel'>
        <div className='wb-panel-head'>
          <Title level={5} className='mb-0'>Operating Empty Weight (OEW)</Title>
          <Space direction='horizontal' size={0} className='ml-auto d-flex'>
            <Upload
              accept='.xlsx,.xls'
              showUploadList={false}
              beforeUpload={(file) => {
                const formData = new FormData()
                formData.append('file', file)

                Http.post(
                  '/w_b/oew',
                  formData,
                  {
                    headers: {
                      'Content-Type': 'multipart/form-data',
                      'station': this.state.station
                    }
                  }
                ).then((data) => {
                  if (data && data?.status === 200) {
                    notification.destroy()
                    notification.success({
                      message: 'Success',
                      description: data?.data?.message,
                    })
                    this.fetchData()
                  } else {
                    notification.destroy()
                    notification.error({
                      message: 'Failed',
                      description: data?.data?.message,
                    })
                  }
                }).catch((err) => {
                  notification.destroy()
                  notification.error({
                    message: 'Failed',
                    description: err?.response?.data?.message || 'Something went wrong',
                  })
                })

                return false // prevent default upload
              }}
            >
              <Button type='link' className='link-btn-dod uld-upload wb-upload-btn' icon={<UploadOutlined style={{ fontSize: 16 }} />}>Upload</Button>
            </Upload>
            <Button className='custom-button' onClick={this.toggleAllAircraft}>
              {isAllExpanded ? 'Collapse All' : 'Expand All'}
            </Button>
          </Space>
        </div>

        {data.length === 0 ? (
          <Card className='wb-type-card'>
            <Empty description='No OEW records found' />
          </Card>
        ) : (
          <div className='wb-card'>
            <Collapse
              activeKey={activeAircraftKeys}
              onChange={this.handleAircraftAccordionChange}
              className='wb-accordion'
              bordered={false}
            >
              {data.map((item, index) => {
                const oewRows = item?.oew || []
                const extraColumns = this.getExtraColumnNames(oewRows)
                const panelKey = this.getAircraftPanelKey(item, index)
                const columns = this.getOewColumns(extraColumns)
                const tableData = oewRows.map((row, rowIndex) => ({
                  ...row,
                  key: `${row?.id || 'row'}-${rowIndex}`
                }))

                return (
                  <Panel key={panelKey} header={`Aircraft Type: ${item?.type || '-'}`} className='wb-accordion-panel'>
                    <div className='table-responsive wb-type-table-wrap'>
                      <div className='wb-grid-shell'>
                        <Table
                          className='custom-table'
                          columns={columns}
                          dataSource={tableData}
                          pagination={false}
                          size='small'
                          locale={{ emptyText: 'No rows available' }}
                        />
                      </div>
                    </div>
                  </Panel>
                )
              })}
            </Collapse>
          </div>
        )}
      </div>
    )
  }

  render() {
    // const { data } = this.state
    const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      // slidesToShow: 7,
      slidesToShow: 9,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 7,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
      ]
    }
    return (
      <div>
        <div>
          <Slider {...settings} className='custom-slider wnb-slider'>
            <div className={`tabs-nested ${this.state.tab === 'oew' ? 'active-tab-nested' : ''}`} onClick={() => this.setState({ tab: 'oew' })}>
              <span>OEW</span>
            </div>
          </Slider>
        </div>
        <div className=''>
          <Card className='custom-card'>
            {this.state.tab === 'oew' && this.oew()}
          </Card>
        </div>
      </div>
    )
  }
}


export default WeightBalance